import { fetchAPI } from './fetchAPI';

// ==================== AgentOps Endpoints ====================

export const getAgentRuns = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.agentName) queryParams.append('agent_name', params.agentName);
  if (params.status) queryParams.append('status', params.status);
  if (params.userId) queryParams.append('user_id', params.userId);
  if (params.sessionId) queryParams.append('session_id', params.sessionId);
  if (params.start_date) queryParams.append('start_date', params.start_date);
  if (params.end_date) queryParams.append('end_date', params.end_date);

  const query = queryParams.toString();
  return fetchAPI(`/agentops/runs${query ? '?' + query : ''}`);
};

export const getAgentRun = async (runId: string): Promise<any> => {
  return fetchAPI(`/agentops/runs/${runId}`);
};

export const getAgentRunSteps = async (runId: string): Promise<any> => {
  return fetchAPI(`/agentops/runs/${runId}/steps`);
};

export const getToolUsage = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();

  if (params.days) queryParams.append('days', params.days);
  if (params.include_timeline) queryParams.append('include_timeline', 'true');
  if (params.client_id) queryParams.append('client_id', params.client_id);
  if (params.project_id) queryParams.append('project_id', params.project_id);
  if (params.start_date) queryParams.append('start_date', params.start_date);
  if (params.end_date) queryParams.append('end_date', params.end_date);

  const query = queryParams.toString();
  return fetchAPI(`/agentops/tools/usage${query ? '?' + query : ''}`);
};

export const getSafetyViolations = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.severity) queryParams.append('severity', params.severity);
  if (params.type) queryParams.append('type', params.type);
  if (params.days) queryParams.append('days', params.days);
  if (params.client_id) queryParams.append('client_id', params.client_id);
  if (params.project_id) queryParams.append('project_id', params.project_id);
  if (params.start_date) queryParams.append('start_date', params.start_date);
  if (params.end_date) queryParams.append('end_date', params.end_date);

  const query = queryParams.toString();
  return fetchAPI(`/agentops/safety/violations${query ? '?' + query : ''}`);
};

export const getSafetyViolation = async (violationId: string): Promise<any> => {
  return fetchAPI(`/agentops/safety/violations/${violationId}`);
};

export const getSafetyStats = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();

  if (params.days) queryParams.append('days', params.days);
  if (params.client_id) queryParams.append('client_id', params.client_id);
  if (params.project_id) queryParams.append('project_id', params.project_id);
  if (params.start_date) queryParams.append('start_date', params.start_date);
  if (params.end_date) queryParams.append('end_date', params.end_date);

  const query = queryParams.toString();
  return fetchAPI(`/agentops/safety/violations/summary${query ? '?' + query : ''}`);
};

export const getMemorySnapshots = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.runId) queryParams.append('run_id', params.runId);
  if (params.memoryType) queryParams.append('memory_type', params.memoryType);
  if (params.operation) queryParams.append('operation', params.operation);
  if (params.client_id) queryParams.append('client_id', params.client_id);
  if (params.project_id) queryParams.append('project_id', params.project_id);

  const query = queryParams.toString();
  return fetchAPI(`/agentops/memory${query ? '?' + query : ''}`);
};

export const getMemorySnapshot = async (memoryId: string): Promise<any> => {
  return fetchAPI(`/agentops/memory/${memoryId}`);
};

export const getMemoryStats = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();

  if (params.days) queryParams.append('days', params.days);
  if (params.runId) queryParams.append('run_id', params.runId);
  if (params.client_id) queryParams.append('client_id', params.client_id);
  if (params.project_id) queryParams.append('project_id', params.project_id);

  const query = queryParams.toString();
  return fetchAPI(`/agentops/memory/stats${query ? '?' + query : ''}`);
};

export const getIncidents = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.runId) queryParams.append('run_id', params.runId);
  if (params.severity) queryParams.append('severity', params.severity);
  if (params.status) queryParams.append('status', params.status);
  if (params.incidentType) queryParams.append('incident_type', params.incidentType);
  if (params.days) queryParams.append('days', params.days);
  if (params.client_id) queryParams.append('client_id', params.client_id);
  if (params.project_id) queryParams.append('project_id', params.project_id);
  if (params.start_date) queryParams.append('start_date', params.start_date);
  if (params.end_date) queryParams.append('end_date', params.end_date);

  const query = queryParams.toString();
  return fetchAPI(`/agentops/incidents${query ? '?' + query : ''}`);
};

export const getIncident = async (incidentId: string): Promise<any> => {
  return fetchAPI(`/agentops/incidents/${incidentId}`);
};

export const getIncidentStats = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();

  if (params.days) queryParams.append('days', params.days);
  if (params.runId) queryParams.append('run_id', params.runId);
  if (params.client_id) queryParams.append('client_id', params.client_id);
  if (params.project_id) queryParams.append('project_id', params.project_id);
  if (params.start_date) queryParams.append('start_date', params.start_date);
  if (params.end_date) queryParams.append('end_date', params.end_date);

  const query = queryParams.toString();
  return fetchAPI(`/agentops/incidents/stats${query ? '?' + query : ''}`);
};

export const acknowledgeIncident = async (incidentId: string): Promise<any> => {
  return fetchAPI(`/agentops/incidents/${incidentId}/acknowledge`, {
    method: 'PATCH'
  });
};

export const resolveIncident = async (incidentId: string, resolutionNotes: string): Promise<any> => {
  return fetchAPI(`/agentops/incidents/${incidentId}/resolve`, {
    method: 'PATCH',
    body: JSON.stringify({ resolution_notes: resolutionNotes })
  });
};

export const deleteAgentRun = async (runId: string): Promise<any> => {
  return fetchAPI(`/genaiops/traces/${runId}`, { method: 'DELETE' });
};

export const bulkDeleteAgentRuns = async (ids: string[]): Promise<any> => {
  return fetchAPI('/genaiops/traces/bulk', {
    method: 'DELETE',
    body: JSON.stringify({ ids }),
  });
};

export const deleteIncident = async (incidentId: string): Promise<any> => {
  return fetchAPI(`/agentops/incidents/${incidentId}`, { method: 'DELETE' });
};

export const bulkDeleteIncidents = async (ids: string[]): Promise<any> => {
  return fetchAPI('/agentops/incidents/bulk', {
    method: 'DELETE',
    body: JSON.stringify({ ids }),
  });
};

export const deleteSafetyViolation = async (violationId: string): Promise<any> => {
  return fetchAPI(`/agentops/safety/violations/${violationId}`, { method: 'DELETE' });
};

export const bulkDeleteSafetyViolations = async (ids: string[]): Promise<any> => {
  return fetchAPI('/agentops/safety/violations/bulk', {
    method: 'DELETE',
    body: JSON.stringify({ ids }),
  });
};

export const assignRunProject = async (runId: string, projectId: string | null): Promise<any> => {
  return fetchAPI(`/agentops/runs/${runId}/project`, {
    method: 'PATCH',
    body: JSON.stringify({ project_id: projectId }),
  });
};

export const bulkAssignRunProject = async (ids: string[], projectId: string | null): Promise<any> => {
  return fetchAPI('/agentops/runs/bulk-assign-project', {
    method: 'PATCH',
    body: JSON.stringify({ ids, project_id: projectId }),
  });
};

export const assignRunWorkload = async (runId: string, workloadId: string | null): Promise<any> => {
  return fetchAPI(`/agentops/runs/${runId}/workload`, {
    method: 'PATCH',
    body: JSON.stringify({ workload_id: workloadId }),
  });
};

export const bulkAssignRunWorkload = async (ids: string[], workloadId: string | null): Promise<any> => {
  return fetchAPI('/agentops/runs/bulk-assign-workload', {
    method: 'PATCH',
    body: JSON.stringify({ ids, workload_id: workloadId }),
  });
};
